<template>
  <v-card flat color="transparent" outlined class="pa-4">
    <v-row align="center" class="mb-4">
      <v-col cols="12">
        <h2 class="font-weight-bold">Historial de precios</h2>
      </v-col>
    </v-row>

    <v-divider class="my-2"></v-divider>

    <v-row v-if="loadingFetch && historial.length === 0" justify="center" class="mt-4">
      <v-progress-circular indeterminate />
    </v-row>

    <v-row v-else-if="historial.length > 0" align="start" justify="center" class="mt-2 mx-auto">
      <v-col cols="12" md="8">
        <v-timeline align-top :reverse="true">
          <v-timeline-item
            v-for="item in historial"
            :key="item.id"
            color="pink"
            small
          >
            <span slot="opposite">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ moment(item.fecha_actualizacion).format("lll") }}
                  </v-list-item-title>
                  <v-list-item-subtitle>{{ item.usuario }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </span>

            <v-hover v-slot="{ hover }" close-delay="100">
              <v-card
                :color="hover ? '#E91E62' : ''"
                :elevation="hover ? 16 : 2"
                :class="{ 'on-hover': hover }"
              >
                <v-container>
                  <v-list-item class="grow">
                    <v-list-item-content>
                      <v-list-item-subtitle>
                        <span style="font-size: 20px">
                          <strong>{{ item.precio_venta_manual | convertPesoArg() }}</strong>
                        </span>
                      </v-list-item-subtitle>
                      <v-list-item-title>
                        <div class="text-caption mb-2">Precio de venta</div>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-row>
                      <v-col cols="6">
                        <strong>{{ item.precio_costo | convertPesoArg() }}</strong>
                        <div class="text-caption mb-2">Precio Costo</div>
                      </v-col>
                      <v-col cols="6">
                        <strong>{{ item.ganancia }}%</strong>
                        <div class="text-caption mb-2">Ganancia</div>
                      </v-col>
                    </v-row>
                  </v-list-item>
                </v-container>
              </v-card>
            </v-hover>
          </v-timeline-item>

          <v-timeline-item v-if="next_page" hide-dot class="mb-4">
            <v-btn @click="fetchNextPage" :loading="loadingFetch" class="mx-0">
              Más
            </v-btn>
          </v-timeline-item>
        </v-timeline>
      </v-col>
    </v-row>

    <v-row v-else align="start" justify="center" class="mt-4">
      <h2 class="grey--text">Sin historial</h2>
    </v-row>
  </v-card>
</template>

<script>
import ProductosAPI from "@/api/productos";

export default {
  name: "SucursalProductoHistorial",
  props: {
    productoProp: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loadingFetch: false,
      historial: [],
      paginacion: { page: 1, rowsPerPage: 12 },
      next_page: false,
    };
  },
  methods: {
    fetchNextPage() {
      this.paginacion.page += 1;
      this.fetchHistorial(this.productoProp.id);
    },
    fetchHistorial(pspId) {
      this.loadingFetch = true;
      ProductosAPI.getPspHistorial(pspId, this.paginacion)
        .then((response) => {
          this.next_page = !!response.data.next;
          const results = response.data.results || [];
          if (this.paginacion.page > 1) {
            this.historial = this.historial.concat(results);
          } else {
            this.historial = results;
          }
        })
        .catch((e) => {
          console.error("Error al obtener historial:", e);
        })
        .finally(() => {
          this.loadingFetch = false;
        });
    },
  },
  watch: {
    productoProp: {
      handler(newVal) {
        if (newVal) {
          this.paginacion.page = 1;
          this.historial = [];
          this.fetchHistorial(newVal.id);
        }
      },
      immediate: true,
    },
  },
};
</script>
